import React from "react";
import FeatureCard from "../FeatureCard";

const RegisterCard = () => (
  <FeatureCard to="/partnership" image="/static/img/Card-RegisterToExplore.png" imageAlt="People pointing at a map" description="Explore the benefits">
    See all the perks of partnering with Skyward to build your next integration
  </FeatureCard>
);

export default RegisterCard;
